import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../stores/Hooks';
import { CollapsibleComponent } from '../components/CollapsibleComponent';
import { FileDropZoneUploaderList } from '../components/FileUploader/FileDropZoneUploaderList';
import { FilesPageRightBlock } from './RightBlock/FilesPageRightBlock';
import { StatementFileTypeModel, StatementTypeEnum } from '../models';

export const FilesPage: React.FC<any> = observer(
	() =>
	{
		const { uiState } = useStores();
		const store = uiState.files;

		function FileTypeComment(val: StatementFileTypeModel) : string
		{
			switch (uiState.register.StatementType)
			{
				case StatementTypeEnum.RemoveInformation: return val.CommentDelete;
				default: return val.Comment;
			}
		}

		// получаем типы, относящиеся к добавляемым услугам
		// также получаем типы, в которых есть хоть один загруженный файл
		let typesArray = store.GetTypesForNewInformation();

		return (
				<div className="row no-gutters scrolled-container">
					<div className="col-lg">
						<div className="info-on-mobile d-lg-none">
							<button
								className="text-primary text-center link d-flex align-items-center f-14"
								type="button"
								onClick={() => uiState.modal.ShowComponent("Информация по разделу", FilesPageRightBlock)}
							>Информация по разделу <img src="./i/icons/question.svg" className="ml-2" alt="Информация по разделу" /></button>
						</div>
						<div className="accordions-container">
							{store.SortedFileTypeArray.map
								((val, ind) =>
								{
									let isCompleted: boolean = false;
									let errorMessage: string | undefined = undefined;
									if (store.FileLists)
									{
										const fileArray = store.FileLists.get(val.Id);
										if (fileArray && typesArray.size>0)
										{
											const res = store.ValidateFileList(typesArray, fileArray, val.Id, undefined);
											if (res.Result)
											{
												isCompleted = true;
											}
											else
											{
												isCompleted = false;
												errorMessage = res.Message;
											}
										}
									}

									return (
										<CollapsibleComponent key={val.Id.replace(/-/gi, "")} IsRequired={val.IsRequired} ID={val.Id.replace(/-/gi, "")} HeaderText={(ind + 1) + '. ' + val.Name} ErrorText={errorMessage} IsCompleted={isCompleted} IsValidated={store.IsValidated} >
											<FileDropZoneUploaderList FileTypeId={val.Id} AllowedExtensions={["pdf", "tiff", "tif"]} Comment={FileTypeComment(val)} />
										</CollapsibleComponent>
									)
								})
							}
						</div>
					</div>
					<div className="col-lg-auto sidebar d-none d-lg-block">
						<FilesPageRightBlock />
					</div>
				</div>
		);
	}
)
